import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedUserGroup } from "types/generated";

type GetApiKeyGroupsData = {
  managedUserGroups: Pick<ManagedUserGroup, "id" | "groupName" | "description">[];
};

export const GET_API_KEY_GROUPS: TypedDocumentNode<GetApiKeyGroupsData> = gql`
  query GetApiKeyGroups {
    managedUserGroups {
      id
      groupName
      description
    }
  }
`;
